import { Badge } from 'antd';
import { observer } from 'mobx-react-lite';

import { EOrderStatus } from '../../core/tickets-order';

type OrderStatusLabelProps = {
  status?: EOrderStatus;
};

export const OrderStatusLabel = observer(
  ({ status }: OrderStatusLabelProps) => {
    if (status == undefined) return null;

    switch (status) {
      case EOrderStatus.created:
        return (
          <Badge
            status="processing"
            text="Создан"
            style={{ whiteSpace: 'nowrap' }}
          />
        );

      case EOrderStatus.ok:
        return (
          <Badge
            status="success"
            text="Выполнен"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EOrderStatus.error:
        return (
          <Badge
            status="error"
            text="Ошибка"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EOrderStatus.booked:
        return (
          <Badge
            status="warning"
            text="Забронирован"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EOrderStatus.canceled:
        return (
          <Badge
            status="default"
            text="Отменен"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      default:
        return null;
    }
  }
);
